module.exports = __webpack_public_path__ + "img/brm1.826b67f4.jpg";